import { Button } from '@components/design-system';
import { styled } from '@styles/stitches';

export const Container = styled('div', {
  [`& ${Button}`]: {
    display: 'flex',
    alignItems: 'center',
    padding: 8,

    i: {
      fontSize: 16,
      marginRight: 4,
    },
  },
});
